module.exports = __webpack_public_path__ + "assets/img/zpimg2.2f93134d.png";